import React, { Component } from 'react';
import './FormError.scss';

export default class FormError extends Component {
  render() {
    return (
      <span className="form_error">
        {this.props.inner}
      </span>
    )
  }
}
